import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'while',
    colour: CATEGORIES.control.color,
    tooltip: '条件が真の間繰り返します',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'value',
            name: 'CONDITION',
            check: 'Boolean',
            fields: [
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('WHILE', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'dummy',
            fields: [{ type: 'label', text: 'の間くりかえす ' }],
        },
        {
            kind: 'statement',
            name: 'DO',
        },
    ],
    onInit(this: Blockly.Block) {
        const input = this.getInput('CONDITION');
        if (!input?.connection || input.connection.targetBlock()) return;
        const shadow = (this.workspace as Blockly.WorkspaceSvg).newBlock('bool');
        shadow.setShadow(true);
        shadow.outputConnection?.connect(input.connection);
        requestAnimationFrame(() => {
            (shadow as Blockly.BlockSvg).initSvg();
            (shadow as Blockly.BlockSvg).render();
        });
    },
});
